import { Route } from 'vue-router'

import UnauthenticatedLanding from '@/components/auth/UnauthenticatedLanding.vue'
import VerifyToken from '@/components/auth/VerifyToken.vue'
import UnsupportedBrowser from '@/components/UnsupportedBrowser.vue'
import SubjectDoesNotExist from '@/components/SubjectDoesNotExist.vue'
import WebChatRoute from '@/components/webchat/WebChatRoute.vue'
import LandingPage from '@/components/LandingPage.vue'
import EntrustWrapper from '@/components/EntrustWrapper.vue'

export default [
  {
    path: '/',
    component: WebChatRoute,
    name: 'chat',
    meta: { requiresAuth: true },
  },
  {
    path: '/summary',
    component: LandingPage,
    name: 'landing-page',
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    component: UnauthenticatedLanding,
    name: 'login',
  },
  {
    path: '/unsupported-browser',
    component: UnsupportedBrowser,
    meta: { requiresAuth: false },
  },
  {
    path: '/complete',
    component: SubjectDoesNotExist,
    meta: { requiresAuth: false },
    name: 'complete',
  },
  {
    path: '/verify',
    component: VerifyToken,
  },
  {
    path: '/entrust',
    component: EntrustWrapper,
    meta: { requiresAuth: false },
    name: 'entrust',
    props: (route: Route) => ({
      sdkToken: route.query.sdkToken,
      workflowRunId: route.query.workflowRunId,
    }),
  },
]
